import { LoanRolloverSplitParams } from 'app/models/loan-rollover-split-params'
import {
  submitForApprovalSplit,
  rejectSelectedLoanRolloverSplit,
  approveSelectedLoanRolloverSplit,
  deleteSelectedLoanRolloverSplit,
  loadAllLoanRolloverSplits,
} from 'app/state/ducks/loan-rollover-splits/thunks'
import {
  ErrorNotification,
  SuccessNotification,
} from 'app/views/components/notifications/notification'
import { Dispatch } from 'redux'

export async function submitLoanRolloverSplit(
  split: LoanRolloverSplitParams,
  dispatch: Dispatch<any>,
) {
  const response: any = await dispatch(submitForApprovalSplit(split))
  if (response.success) {
    SuccessNotification({
      title: 'Successful Submission',
      message: 'Loan Rollover Split has been Submitted for Approval',
    })
  } else {
    ErrorNotification({
      title: 'Submission Failed',
      message: response.payload ?? 'Could not submit Loan Rollover Split',
    })
  }
  dispatch(loadAllLoanRolloverSplits())
}

export async function rejectLoanRolloverSplit(
  split: LoanRolloverSplitParams,
  dispatch: Dispatch<any>,
) {
  const response: any = await dispatch(rejectSelectedLoanRolloverSplit(split))
  if (response.success) {
    SuccessNotification({
      title: 'Successful Rejection',
      message: 'Loan Rollover Split has been moved back to a Draft',
    })
  } else {
    ErrorNotification({
      title: 'Rejection Failed',
      message: response.payload ?? 'Could not reject Loan Rollover Split',
    })
  }
  dispatch(loadAllLoanRolloverSplits())
}

export async function approveLoanRolloverSplit(
  split: LoanRolloverSplitParams,
  dispatch: Dispatch<any>,
) {
  const response: any = await dispatch(approveSelectedLoanRolloverSplit(split))
  if (response.success) {
    SuccessNotification({
      title: 'Successful Approval',
      message: 'Loan Rollover Split has been Approved',
    })
  } else {
    ErrorNotification({
      title: 'Approval Failed',
      message: response.payload ?? 'Could not approve Loan Rollover Split',
    })
  }
  dispatch(loadAllLoanRolloverSplits())
}

export async function deleteLoanRolloverSplit(
  split: LoanRolloverSplitParams,
  dispatch: Dispatch<any>,
) {
  const response: any = await dispatch(deleteSelectedLoanRolloverSplit(split))
  if (response.success) {
    SuccessNotification({
      title: 'Successful Deletion',
      message: 'Loan Rollover Split has been Deleted',
    })
  } else {
    ErrorNotification({
      title: 'Delete Failed',
      message: response.payload ?? 'Could not delete Loan Rollover Split',
    })
  }
  dispatch(loadAllLoanRolloverSplits())
}
